/**
 *
 * @author Aleynikov Boris <alynikov.boris@gmail.com>.
 */

'use strict';

/*eslint-disable*/
// disable linting this page till it will be reworked

var id         = 'pSettings',
    Page       = require('stb-component-page'),
    page       = new Page({$node: document.getElementById(id)}),
    app        = require('mag-app'),
    keys       = require('stb-keys'),
    PanelSet   = require('mag-component-panel-set'),
    Panel      = require('mag-component-panel'),
    LayoutList = require('mag-component-layout-list'),
    ScrollArea = require('mag-component-scroll-area'),
    popup      = require('../modules/settings/modal')(page),
    equalizer  = require('../modules/ui/equalizer'),
    optionsData,
    mainSet,
    menuList, settingsList, description, restoreEqualizer;


optionsData = [
    {
        items: makeItem('theme-icon theme-icon-volume', _('Sound')),
        options: require('../modules/settings/sound.options'),
        title: _('Sound')
    },
    {
        items: makeItem('theme-icon theme-icon-display', _('Display')),
        options: require('../modules/settings/display.options'),
        title: _('Display')
    }
];
if ( core.device && core.device.model === 'emulator' ) {
    optionsData.push({
        items: makeItem('theme-icon theme-icon-monitor', _('Video')),
        options: require('../modules/settings/video.options'),
        title: _('Video')
    })
}


mainSet = new PanelSet({
    panels: [
        new Panel({
            title: _('Settings'),
            children: [
                menuList = new LayoutList({
                    data: optionsData
                })
            ]
        }),
        new Panel({
            title: _('Sound'),
            main: true,
            children: [
                settingsList = new LayoutList()
            ]
        }),
        new Panel({
            title: _('Info'),
            children: [
                description = new ScrollArea({
                    propagate: true
                })
            ]
        })
    ]
});

page.add(mainSet);
settingsList.emit('focus:item', {$curr: settingsList.$focusItem});

menuList.addListener('focus:item', function ( event ) {
    mainSet.panels[1].$title.$node.childNodes[0].innerText = event.$curr.layout.data[1].value;


    if ( typeof  event.$curr.data.options === 'function' ) {
        //event.$curr.data.options = event.$curr.data.options();
        settingsList.setData({
            data: event.$curr.data.options(),
            focusIndex: 0
        });
    } else {
        settingsList.setData({
            data: event.$curr.data.options,
            focusIndex: 0
        });
    }

    settingsList.emit('focus:item', {$curr: settingsList.$focusItem});
});


settingsList.addListener('focus:item', function ( event ) {
    description.$body.innerText = event.$curr.data.description || '';
    description.init();
});


settingsList.addListener('click:item', function ( event ) {
    var data = event.$item.data;

    if ( data.type === 'checkBox' ) {
        // reverse check box value and update className
        data.setValue(!data.getValue(), event.$item);
    } else {
        mainSet.blur();
        app.activePage.activeComponent.blur();
        // console.log(app.activePage.activeComponent);
        popup({
            title: data.items[1].value,
            data: data.options,
            getOptions: data.getOptions,
            getFocusIndex: data.getFocusIndex,
            handler: data.handler,
            onShow: function () {
                // setTimeout(
                //     function () {
                //     }, 37
                // );
            },
            onHide: function () {
                setTimeout(
                    function () {
                        mainSet.focus();
                    }, 37
                );

            }
        })
    }
});


function makeItem ( icon, text ) {
    if ( typeof  text === 'function' ) {
        text = text();
    }

    return  [
        {
            className: icon
        },
        {
            value: text
        }
    ];
}

page.addListener('keydown', function ( event ) {
    switch ( event.code ) {
        case keys.back:

            // modal popup do some async calls and we should prevent go back when it's not visible yet
            if ( !page.activeComponent ) {
                return;
            }
            if ( restoreEqualizer ) {
                restoreEqualizer = false;
                equalizer.show();
            }
            app.route(app.pages.main);
            break;
        // small hack. need to correct in future
        case 48:
        case 49:
        case 50:
        case 51:
        case 52:
        case 53:
        case 54:
        case 55:
        case 56:
        case 57:
            event.stop = true;
            break;
    }
});


page.addListener('show', function () {
    mainSet.panels[0].focus();
    menuList.focusIndex(0);
    if ( equalizer.active ) {
        restoreEqualizer = true;
        equalizer.hide();
    }
});


module.exports = page;
